import request from "@/utils/request";

/**
 * 帖子点赞相关 API
 */

/**
 * 点赞帖子
 * @param {number} postId 帖子ID
 * @returns {Promise}
 */
export function likePost(postId) {
  return request.post(`/api/post/like/${postId}`);
}

/**
 * 取消点赞
 * @param {number} postId 帖子ID
 * @returns {Promise}
 */
export function unlikePost(postId) {
  return request.delete(`/api/post/like/${postId}`);
}

/**
 * 当前用户点赞的帖子分页
 * @param {number} pageNum
 * @param {number} pageSize
 * @returns {Promise}
 */
export function getPostLikePageCurrentUser(pageNum = 1, pageSize = 10) {
  return request.get("/api/post/like/page/currentUser", {
    params: { pageNum, pageSize },
  });
}
